import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MicroComponents from "./MicroComponents";
import { AppState } from "../../../../../stateManager/store";
import { addWrapperComputedStyles, removeElement } from "../../../../../stateManager/store/formCreation_v2/actions";
import { getChildren } from "../helpers";
import { useToast } from "../../../../../helpers/commonFunction";
import { getComponents } from "../helpers/assetHelpers";
import { CustomModal } from "./CustomModal";
import { DeviceType } from "../../../../../stateManager/store/formCreation_v2/types";
import { getElementStyleByType } from "../helpers/formsv3/getComputedValues";


interface IModalRender {
  isCoreV3: boolean
  deviceType: DeviceType
  isCheckedIn: boolean
}

export const ModalRenderer = (props: IModalRender) => {
  const dispatch = useDispatch();
  const modal = useSelector((state: AppState) => state.formJson.modal);
  const { componentId, visible, isCustom } = modal;
  const { selectedElementId } = useSelector((state: AppState) => state.formJson);
  const { components } = getComponents()
  const component = components[componentId]
  const { SuccessToast } = useToast()

  useEffect(() => {
    let timer;
    if (component) {
      const { type, id } = component;
    if (type === "CustomModal") {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        if (document.getElementById(`${type}-${id}`)) {
          const styles = getElementStyleByType(type, id)
          dispatch(addWrapperComputedStyles(styles))
        }
      }, 0)
    }
    }
  }, [component]);

  if (!visible || !component) {
    return null;
  }

  const removeSelectedElement = (e: React.MouseEvent<SVGElement, MouseEvent>) => {
    e.stopPropagation()
    dispatch(
      removeElement({
        id: component.id,
        parentId: component.parentId,
        type: component.type,
      })
    );
  };

  const copySelectedElement = async (e: React.MouseEvent<SVGElement, MouseEvent>) => {
    e.stopPropagation();
    const rootComponent = { ...components[selectedElementId] }
    const copiedComponents: any = {
      [selectedElementId]: rootComponent
    }

    const componentIds = getChildren(rootComponent.fields, components)
    componentIds.forEach(id => {
      copiedComponents[id] = { ...components[id] }
    })

    const data = {
      componentOrder: [selectedElementId],
      components: copiedComponents,
    }

    try {
      await navigator.clipboard.writeText(JSON.stringify(data));
      SuccessToast("Copied")
    } catch (err) {
      console.error("failed to copy text: ", err);
    }
  }

  return isCustom ? (
    <CustomModal isCoreV3={props.isCoreV3} element={component} deviceType={props.deviceType} isCheckedIn={props.isCheckedIn} />
  ) : (
    <MicroComponents element={component} deviceType={props.deviceType} onDelete={removeSelectedElement} onCopy={copySelectedElement} />
  );
};